export default __webpack_public_path__ + "static/media/Thivolan_M.4323e057.jpg";